import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./DataRefreshPill.css";

interface NewPostsPillProps {
    text?: string;
  visible: boolean;
  onClick: () => void;
  loading?: boolean;
}

const DataRefreshPill: React.FC<NewPostsPillProps> = ({
    text = "New posts",
  visible,
  onClick,
  loading = false,
}) => {
  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          className="new-posts-pill"
          onClick={onClick}
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -40, opacity: 0 }}
          transition={{ type: "spring", stiffness: 250, damping: 22 }}
        >
          {loading ? (
            <div className="pill-loader">
              {[...Array(12)].map((_, i) => (
                <span key={i} className="pill-loader-bar"></span>
              ))}
            </div>
          ) : (
            <div className="pill-content">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                className="arrow-icon"
              >
                <path
                  fill="currentColor"
                  d="M8 3l5 5H9v5H7V8H3z"
                />
              </svg>
              <span>{text}</span>
            </div>
          )}
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default DataRefreshPill;
